<template>
 

  <footer class="container mx-auto bg-white py-8 border-t border-gray-400">
    <div class="container flex px-3 py-8">
      <div class="w-full mx-auto flex flex-wrap">
        <div class="flex w-full lg:w-1/2">
          <div class="px-3 md:px-0">
            <h3 class="font-bold text-gray-900">About</h3>
            <p class="py-4">
              Art burn is a project by Eivind Kleiven. He will make announcements on his twitter account.
            </p>
          </div>
        </div>
        <div class="flex w-full lg:w-1/2 lg:justify-end lg:text-right">
          <div class="px-3 md:px-0">
            <h3 class="font-bold text-gray-900">Social</h3>
            <ul class="list-reset items-center pt-3">
              <li>
                          <follow-on-twitter />

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import FollowOnTwitter from './FollowOnTwitter.vue';

export default {
  name: "Footer",
  props: {

  },
  components:{
    FollowOnTwitter
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
